<template>
  <div>

    <div class="card mb-3">
      <div class="card-header">
        <i class="fa fa-bar-chart"></i> {{ $t('dashboard.event.title') }}

        <div class="float-right" >
          <a href="#filter" name="filter" v-on:click="expandOrCollapseFilter">
              <span class="fa fa-expand fa-lg" v-if="!filterVisible" ></span>
              <span class="fa fa-compress fa-lg" v-if="filterVisible"></span>
          </a>
        </div>
      </div>
      <div class="card-body" v-if="filterVisible">
        
        <div class="row">

          <div class="form-group col-md-6">
            <label for="regionInput">{{ $t('dashboard.event.form.businessLevels') }}</label>
            <multiselect v-model="filter.businessLevels" track-by="item1" label="item2"
              :options="businessLevels" :multiple="true" :taggable="false"
              v-bind:placeholder="$t('dashboard.event.form.businessLevels')" 
              v-bind:deselect-label="$t('multiselect.deselect-label')"
              v-bind:select-label="$t('multiselect.selectedLabel')">
            </multiselect>
          </div>

          <div class="form-group col-md-6">
            <label for="regionInput">{{ $t('dashboard.event.form.eventDetailTypes') }}</label>
            <multiselect v-model="filter.eventDetailTypes" track-by="item1" label="item2"
              :options="eventDetailTypes" :multiple="true" :taggable="false"
              v-bind:placeholder="$t('dashboard.event.form.eventDetailTypes')" 
              v-bind:deselect-label="$t('multiselect.deselect-label')"
              v-bind:select-label="$t('multiselect.selectedLabel')">
            </multiselect>
          </div>

          <div class="form-group col-md-6">
            <label for="regionInput">{{ $t('dashboard.event.form.eventTypes') }}</label>
            <multiselect v-model="filter.eventTypes" track-by="item1" label="item2"
              :options="eventTypes" :multiple="true" :taggable="false"
              v-bind:placeholder="$t('dashboard.event.form.eventTypes')" 
              v-bind:deselect-label="$t('multiselect.deselect-label')"
              v-bind:select-label="$t('multiselect.selectedLabel')">
            </multiselect>
          </div>

          <div class="form-group col-md-6">
            <label for="regionInput">{{ $t('dashboard.event.form.natureOfOrganizations') }}</label>
            <multiselect v-model="filter.natureOfOrganizations" track-by="item1" label="item2"
              :options="natureOfOrganizations" :multiple="true" :taggable="false"
              v-bind:placeholder="$t('dashboard.event.form.natureOfOrganizations')" 
              v-bind:deselect-label="$t('multiselect.deselect-label')"
              v-bind:select-label="$t('multiselect.selectedLabel')">
            </multiselect>
          </div>

          <div class="form-group col-md-6">
            <label for="regionInput">{{ $t('dashboard.event.form.participantCounts') }}</label>
            <multiselect v-model="filter.participantCounts" track-by="item1" label="item2"
              :options="participantCounts" :multiple="true" :taggable="false"
              v-bind:placeholder="$t('dashboard.event.form.participantCounts')" 
              v-bind:deselect-label="$t('multiselect.deselect-label')"
              v-bind:select-label="$t('multiselect.selectedLabel')">
            </multiselect>
          </div>

          <div class="form-group col-md-6">
            <label for="regionInput">{{ $t('dashboard.event.form.sectors') }}</label>
            <multiselect v-model="filter.sectors" track-by="item1" label="item2"
              :options="sectors" :multiple="true" :taggable="false"
              v-bind:placeholder="$t('dashboard.event.form.sectors')" 
              v-bind:deselect-label="$t('multiselect.deselect-label')"
              v-bind:select-label="$t('multiselect.selectedLabel')">
            </multiselect>
          </div>

          <div class="form-group col-md-6">
            <label for="regionInput">{{ $t('dashboard.event.form.regions') }}</label>
            <multiselect v-model="filter.regions" track-by="item1" label="item2"
              :options="regions" :multiple="true" :taggable="false"
              v-bind:placeholder="$t('dashboard.event.form.regions')" 
              v-bind:deselect-label="$t('multiselect.deselect-label')"
              v-bind:select-label="$t('multiselect.selectedLabel')">
            </multiselect>
          </div>

          <div class="form-group col-md-6">
            <label for="regionInput">{{ $t('dashboard.event.form.personTypes') }}</label>
            <multiselect v-model="filter.personTypes" track-by="item1" label="item2"
              :options="personTypes" :multiple="true" :taggable="false"
              v-bind:placeholder="$t('dashboard.event.form.personTypes')" 
              v-bind:deselect-label="$t('multiselect.deselect-label')"
              v-bind:select-label="$t('multiselect.selectedLabel')">
            </multiselect>
          </div>

          <div class="form-group col-md-6">
            <label for="regionInput">{{ $t('dashboard.event.form.projectTypes') }}</label>
            <multiselect v-model="filter.projectTypes" track-by="item1" label="item2"
              :options="projectTypes" :multiple="true" :taggable="false"
              v-bind:placeholder="$t('dashboard.event.form.projectTypes')" 
              v-bind:deselect-label="$t('multiselect.deselect-label')"
              v-bind:select-label="$t('multiselect.selectedLabel')">
            </multiselect>
          </div>

          <div class="form-group col-md-6">
            <label for="regionInput">{{ $t('dashboard.event.form.locations') }}</label>
            <multiselect v-model="filter.locations" track-by="key" label="value"
              :options="locations" :multiple="true" :taggable="false"
              v-bind:placeholder="$t('dashboard.event.form.locations')" 
              v-bind:deselect-label="$t('multiselect.deselect-label')"
              v-bind:select-label="$t('multiselect.selectedLabel')">
            </multiselect>
          </div>

          <div class="form-group col-md-2"> 
            <label >{{ $t('dashboard.event.form.dateFrom') }}</label>
            <moment-date-picker v-model="filter.dateFrom" :required="false"></moment-date-picker>
          </div>

          <div class="form-group col-md-2">
            <label>{{ $t('dashboard.event.form.dateTo') }}</label>
            <moment-date-picker v-model="filter.dateTo" :required="false"></moment-date-picker>
          </div>

        </div>

      </div>
    </div>

    <div class="row" v-if="data.length == 0">
      
      <div class="col-xl-12 col-sm-6 mb-4" >
        <div :class="'card text-white o-hidden bg-secondary h-100'">
          <div class="card-body">
            <div class="card-body-icon">
              <i class="fa fa-spinner"></i>
            </div>
            <div class="mr-5">{{ $t("loading")}}</div>
          </div>
        </div>
      </div>
    
    </div>

    <div v-if="data.length != 0">
      <div class="row" >
        <div class="col-md-3" >

          <div class="row">
            <div class="col-sm-12 mb-3" >
              <div class="card text-white o-hidden bg-primary mb-3">
                
                 <div class="card-body">
                  <div class="card-body-icon">
                    <i class="fa fa-fw fa-sign-out"></i>
                  </div>
                  <div class="mr-5">{{ $t("dashboard.event.data.title") }}</div>
                </div>
                
                <ul class="list-group list-group-flush text-dark">
                  <li class="list-group-item"> {{ $t("dashboard.event.data.quantityMemberActif") }} 
                    <span class="pull-right"><strong>{{ quantityMemberActif }}</strong></span>
                  </li>
                  <li class="list-group-item"> {{ $t("dashboard.event.data.quantity") }} 
                    <span class="pull-right"><strong>{{ quantity }}</strong></span>
                  </li>
                  <li class="list-group-item"> {{ $t("dashboard.event.data.participation") }} 
                    <span class="pull-right"><strong>{{ participation }} %</strong></span>
                  </li>
                  
                </ul>
              </div>
              
            </div>
          </div>

        </div>

        <div class="col-md-9" >

          <div class="col-md-12"  >

            <div class="card mb-3" v-if="interestRatioData != null">
              <div class="card-header">
                <i class="fa fa-pie-chart"></i> {{ $t("dashboard.event.data.interestRatio") }} 
              </div>
              <bar-chart :chart-data="interestRatioData.data" :options="interestRatioData.options"></bar-chart>
            </div>

          </div>

          <div class="col-md-12"  >

            <div class="card mb-3" v-if="eventsData != null">
              <div class="card-header">
                <i class="fa fa-pie-chart"></i> {{ $t("dashboard.event.data.eventsData") }} 
              </div>
              <bar-chart :chart-data="eventsData.data" :options="eventsData.options"></bar-chart>
            </div>

          </div>

        </div>

      </div>
    </div>

  </div>
</template>

<script>
import ServiceFactory from '../../shared/service-clients/serviceClientFactory'
import {
  CompanyServiceClient,
  ProjectServiceClient,
  InvestmentServiceClient,
  AddressServiceClient,
  RoleServiceClient,
  ExitServiceClient,
  EventServiceClient,
  MemberServiceClient,
} from '../../shared/service-clients/service-clients'

import DashboardMixin from '../../shared/Mixin/DashboardMixin'

export default {
  name: 'EventDashboard',
  mixins: [DashboardMixin],
  data() {
    return {
      data: [],
      businessLevels: [],
      eventDetailTypes: [],
      eventTypes: [],
      natureOfOrganizations: [],
      participantCounts: [],
      sectors: [],
      regions: [],
      personTypes: [],
      locations: [],
      projectTypes: [],
      filter: {
        businessLevels: [],
        eventDetailTypes: [],
        eventTypes: [],
        natureOfOrganizations: [],
        participantCounts: [],
        sectors: [],
        regions: [],
        personTypes: [],
        projectTypes: [],
        locations: [],
        dateFrom: null,
        dateTo: null,
      },
    }
  },
  computed: {
    filteredData: function() {
      let filtered = this.data.items

      filtered = this.filterPropertyByList(filtered, this.filter.businessLevels, 'businessLevel')
      filtered = this.filterPropertyByList(filtered, this.filter.eventDetailTypes, 'detailType')
      filtered = this.filterPropertyByList(filtered, this.filter.eventTypes, 'type')
      filtered = this.filterPropertyByList(filtered, this.filter.natureOfOrganizations, 'natureOfOrganization')
      filtered = this.filterPropertyByList(filtered, this.filter.participantCounts, 'participantCount')
      filtered = this.filterPropertyByList(filtered, this.filter.sectors, 'sectorOfActivity')
      filtered = this.filterPropertyByList(filtered, this.filter.regions, 'region')
      filtered = this.filterPropertyByList(filtered, this.filter.projectTypes, 'projectType')
      filtered = this.filterPropertyByList(filtered, this.filter.personTypes, 'personTypeOrganizer')
      filtered = this.filterPropertyByList(filtered, this.filter.locations, 'meetingLocation')

      filtered = this.filterPropertyByDateTo(filtered, this.filter.dateFrom, 'date')
      filtered = this.filterPropertyByDateFrom(filtered, this.filter.dateTo, 'date')

      return _.orderBy(filtered, o => o.date)
    },
    quantity: function() {
      return this.filteredData.length
    },
    quantityMemberActif: function() {
      return this.data.activeMembers.length
    },
    participation: function() {
      // nb de membres actifs en date du jour ayant participé à une activité (donc coche présent = oui dans une activité) divisé par le nombre total de membres actifs en date du jour
      let participationMembers = _.chain(this.filteredData)
        .flatMap('eventPersons')
        .map(m => ({memberId: m.memberId}))
        .filter(f => f.memberId != null)
        .groupBy('memberId')
        .map((groups, key) => ({memberId: parseInt(key)}))
        .value()

      let actifParticipationMembers = _.filter(participationMembers, x => _.find(this.data.activeMembers, f => f == x.memberId))

      return (actifParticipationMembers.length / this.quantityMemberActif * 100).toFixed(2)
    },
    interestRatioData: function() {
      let data = _.chain(this.filteredData)
        .filter(f => f.type == 2)
        .groupBy(o => moment(o.date).format(this.groupFormat))
        .map((items, key) => ({
          key: key,
          membres: _.chain(items)
            .flatMap('eventPersons')
            .map(m => ({memberId: m.memberId, qtdInterets: m.qtdInterets, meetingLocation: m.meetingLocation}))
            .filter(f => f.memberId != null)
            .value(),
        }))
        .map(m => ({
          key: m.key,
          quebec: (
            _.chain(m.membres)
              .filter(f => f.meetingLocation == 1 || f.meetingLocation == 5)
              .sumBy(s => s.qtdInterets)
              .value() / _.filter(m.membres, f => f.meetingLocation == 1 || f.meetingLocation == 5).length
          ).toFixed(2),
          montreal: (
            _.chain(m.membres)
              .filter(f => f.meetingLocation == 2)
              .sumBy(s => s.qtdInterets)
              .value() / _.filter(m.membres, f => f.meetingLocation == 2).length
          ).toFixed(2),
          sherbrooke: (
            _.chain(m.membres)
              .filter(f => f.meetingLocation == 3)
              .sumBy(s => s.qtdInterets)
              .value() / _.filter(m.membres, f => f.meetingLocation == 3).length
          ).toFixed(2),
        }))
        .value()

      return this.generateBarChartFromData(data, 'dashboard.event', false, 'quebec', 'montreal', 'sherbrooke')
    },
    groupFormat: function() {
      return this.getDateTimeGroupFormat(this.filteredData, 'date')
    },
    eventsData: function() {
      let data = _.chain(this.filteredData)
        .groupBy(o => moment(o.date).format(this.groupFormat))
        .map((items, key) => ({
          key: key,
          external: _.filter(items, f => f.type == 1).length,
          montlyMeeting: _.filter(items, f => f.type == 2).length,
          pitchTest: _.filter(items, f => f.type == 3).length,
          internal: _.filter(items, f => f.type == 4).length,
        }))
        .value()

      return this.generateBarStackedChartFromData(data, 'dashboard.event', false, 'external', 'montlyMeeting', 'pitchTest', 'internal')
    },
  },
  methods: {
    fetchData: function() {
      let self = this
      // Workaround for the first time hit bug
      // TODO : Essayer de comprends qqs se passe...
      let pingService = ServiceFactory.create(RoleServiceClient)
      pingService.getAll(0, 1).then(rest => {
        let eventService = ServiceFactory.create(EventServiceClient)
        let companyService = ServiceFactory.create(CompanyServiceClient)
        let addressService = ServiceFactory.create(AddressServiceClient)
        let memberService = ServiceFactory.create(MemberServiceClient)

        self.getDashboardData(eventService)
        self.getFilterData(eventService, companyService, memberService, addressService)
      })
    },
    getFilterData: function(eventService, companyService, memberService, addressService) {
      let self = this

      let getBusinessLevel = eventService.getBusinessLevel()
      let getEventDetailType = eventService.getEventDetailType()
      let getEventType = eventService.getEventType()
      let getNatureOfOrganization = eventService.getNatureOfOrganization()
      let getParticipantCount = eventService.getParticipantCount()
      let getCompanySector = companyService.getSectorOfActivity()
      let getRegions = addressService.getRegions()
      let getPersonType = eventService.getEventPersonType()
      let getLocations = addressService.getLocations()

      let getProjectType = eventService.getProjectType()

      getProjectType.then(res => {
        self.projectTypes = res
      })
      getBusinessLevel.then(res => {
        self.businessLevels = res
      })
      getEventDetailType.then(res => {
        self.eventDetailTypes = res
      })
      getEventType.then(res => {
        self.eventTypes = res
      })
      getNatureOfOrganization.then(res => {
        self.natureOfOrganizations = res
      })
      getParticipantCount.then(res => {
        self.participantCounts = res
      })
      getCompanySector.then(res => {
        self.sectors = res
      })
      getRegions.then(res => {
        self.regions = res
      })
      getPersonType.then(res => {
        self.personTypes = res
      })
      getLocations.then(res => {
        self.locations = res
      })
    },
    getDashboardData: function(service) {
      let self = this
      service
        .getDashboardData()
        .then(res => {
          self.data = res
          this.filterVisible = true
        })
        .catch(err => {
          console.log(err)
        })
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Event.vue